export const CheckIcon = (props: any) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M13.0107 4.30868C12.5804 3.89711 11.8829 3.89711 11.4527 4.30868L6.16387 9.45532L4.54732 7.90929C4.11713 7.49766 3.41955 7.49766 2.98937 7.90929C2.55913 8.32092 2.55913 8.98828 2.98937 9.39991L5.38495 11.6913C5.60004 11.8971 5.88203 12 6.16398 12C6.44592 12 6.72786 11.8971 6.94301 11.6913L13.0107 5.7993C13.4409 5.38767 13.4409 4.72031 13.0107 4.30868Z"
			fill={props.fill ?? '#24C875'}
		/>
	</svg>
);
